module.exports = __webpack_public_path__ + "static/media/Greenland_Escape_2026_PDF.ac1b503c.pdf";